export enum ENDPOINTS {
  CLEANERS = 'cleaners',
  FAVORITES = 'favorites',
  USERS = 'users',
  BOOKINGS = 'bookings',
  CHATS = 'chats',
  METRICS = 'metrics',
  STRIPE = 'stripe',
}
